<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>基本兵役資料</h2>

      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>基本兵役資料</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div id="tabs-01" class="row">
      <div class="col-md-13">
        <section class="panel">
          <header class="panel-heading">
            <h2 class="panel-title">基本兵役資料</h2>
          </header>
          <div class="panel-body">
            <div class="form-group">
              <div class="group">
                <label class="col-sm-2">學　　　制：</label>
                <div class="col-sm-4">{{item.educateSystem}}</div>
              </div>
              <div class="group">
                <label class="col-sm-2">科　　　系：</label>
                <div class="col-sm-4">{{item.deptName}}</div>
              </div>
            </div>
            <div class="form-group">
              <div class="group">
                <label class="col-sm-2">年級／班級：</label>
                <div class="col-sm-4">{{item.dradeClass}}</div>
              </div>
              <div class="group">
                <label class="col-sm-2">姓　　　名：</label>
                <div class="col-sm-4">{{item.studentName}}</div>
              </div>
            </div>
            <div class="form-group">
              <div class="group">
                <label class="col-sm-2">生　　　日：</label>
                <div class="col-sm-4">{{item.birthday}}</div>
              </div>
              <div class="group">
                <label class="col-sm-2">身　分　證：</label>
                <div class="col-sm-4">{{item.idno}}</div>
              </div>
            </div>
            <div class="form-group">
              <div class="group">
                <label class="col-sm-2">學　　　號：</label>
                <div class="col-sm-4">{{item.studentId}}</div>
              </div>
              <div class="group">
                <label class="col-sm-2">電　　　話：</label>
                <div class="col-sm-4">{{item.tel}}</div>
              </div>
            </div>
            <div class="form-group">
              <div class="group">
                <label class="col-sm-2">手　　　機：</label>
                <div class="col-sm-4">{{item.phone}}</div>
              </div>
              <div class="group">
                <label class="col-sm-2">地　　　址：</label>
                <div class="col-sm-4">{{item.address}}</div>
              </div>
            </div>
            <div class="form-group">
              <div class="group">
                <label class="col-sm-2">入 學 日 期 ：</label>
                <div class="col-sm-4">{{item.entryYM}}</div>
              </div>
              <div class="group">
                <label class="col-sm-2">預計畢業日：</label>
                <div class="col-sm-4">{{item.preGradYM}}</div>
              </div>
            </div>
            <div class="form-group">
              <div class="group">
                <label class="col-sm-2">在 學 狀 態 ：</label>
                <div class="col-sm-4">
                  {{item.state}}
                  <span style="margin-left: 10px;" v-if="(item.state=='休學'||item.state=='轉學'||item.state=='退學')&&item.restOrOutDate">
                    ( 離校日期: {{item.restOrOutDate}} )
                  </span>
                </div>
              </div>
              <div class="group">
                <label class="col-sm-2">備　　　考：</label>
                <div class="col-sm-4">{{item.reference}}</div>
              </div>
            </div>
            <div class="form-group">
              <div class="group">
                <label class="col-sm-3">當 兵 狀 態 ：</label>
                <div class="col-sm-9">
                  <select v-model="form.status" @change.prevent="statusChagne">
                    <option :value="null">請選擇</option>
                    <option value="未役">未役</option>
                    <option value="已役">已役</option>
                    <option value="其他">其他</option>
                  </select>　
                  <div v-if="form.status=='已役'" style="display: inline-block; margin-left: 5px;">
                    階級：<select v-model="form.commission">
                      <option :value="null">請選擇</option>
                      <option value="二等兵">二等兵</option>
                      <option value="一等兵">一等兵</option>
                      <option value="上等兵">上等兵</option>
                      <option value="下士">下士</option>
                      <option value="中士">中士</option>
                      <option value="上士">上士</option>
                      <option value="士官長">士官長</option>
                      <option value="補充兵">補充兵</option>
                    </select>
                  </div>
                  <div v-if="form.status=='其他'" style="display: inline-block; margin-left: 5px;">
                    <select v-model="form.otherReason">
                      <option :value="null">請選擇</option>
                      <option value="停役">停役</option>
                      <option value="免役">免役</option>
                      <option value="現役">現役</option>
                      <option value="除役">除役</option>
                      <option value="替代役">替代役</option>
                      <option value="國民兵">國民兵</option>
                    </select>
                  </div>
                  <div v-if="form.status=='已役'||form.status=='其他'" style="display: inline-block; margin-left: 5px;">
                    佐證資料：<input ref="evidenceFile" type="file" style="display: inline-block; max-width: 150px;" />
                    <a :href="item.evidenceFile" v-if="item.evidenceFile" style="margin-left: 5px;">已上傳之佐證資料</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="group">
                <label class="col-sm-2">身分證正面：</label>
                <div class="col-sm-4">
                  <div v-if="item.idCardPosit" style="position:relative;">
                    <div v-if="checkIdCardFileIsImage(item.idCardPosit)">
                      <a href="#" @mouseover="idCardShow(0)" @mouseout="idCardHide(0)">{{item.studentName}}身分證正面</a>
                      <div ref="divIdCardPosit" class="box" style="bottom:100%; margin:0; width:400px; text-align:center;">
                        <h4 class="blue">姓名：{{item.studentName}}　身分證字號：{{item.idno}}</h4>
                        <img :src="item.idCardPosit" style="max-width:400px; max-height:174px;">
                      </div>
                    </div>
                    <div v-else>
                      <a :href="item.idCardPosit" target="_blank">{{item.studentName}}身分證正面</a>
                    </div>
                  </div>
                  <input ref="idCardPosit" type="file" accept=".jpg,.png,.pdf" v-show="!item.adminCheck" />
                </div>
              </div>
              <div class="group">
                <label class="col-sm-2">身分證反面：</label>
                <div class="col-sm-4">
                  <div v-if="item.idCardRever" style="position:relative;">
                    <div v-if="checkIdCardFileIsImage(item.idCardRever)">
                      <a href="#" @mouseover="idCardShow(1)" @mouseout="idCardHide(1)">{{item.studentName}}身分證反面</a>
                      <div ref="divIdCardRever" class="box" style="bottom:100%; margin:0; width:400px; text-align:center;">
                        <h4 class="blue">姓名：{{item.studentName}}　身分證字號：{{item.idno}}</h4>
                        <img :src="item.idCardRever" style="max-width:400px; max-height:174px;">
                      </div>
                    </div>
                    <div v-else>
                      <a :href="item.idCardRever" target="_blank">{{item.studentName}}身分證反面</a>
                    </div>
                  </div>
                  <input ref="idCardRever" type="file" accept=".jpg,.png,.pdf" v-show="!item.adminCheck" />
                </div>
              </div>
            </div>
            <br><br />
            <table width="100%">
              <tr>
                <td align="center">
                  <a href="#" @click.prevent="formSubmit" v-if="item.adminCheck!=true" class="btn-upload btn" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;">儲　　存</a>
                  <a href="#" v-else class="btn-upload btn disabled" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;">資料已審核通過</a>
                </td>
              </tr>
            </table>
          </div>
        </section>
      </div>
    </div>
  </section>

</template>

<script>
export default {
  data() {
    return {
      item: {},
      form: {
        status: null,
        commission: null,
        otherReason: null,
        evidenceFile: null,
        idCardPosit: null,
        idCardRever: null
      },
      tempEvidenceFile: null
    };
  },
  async mounted() {
    let r = await new Promise(resolve => {
      this.$http.get("/api/military/opening-date").then(a => {
        if (!a.body) {
          alert("功能尚未開放");
          this.$router.go(-1);
          return resolve(false);
        } else {
          let d = this.nowDate();
          let sd = new Date(a.body.startDate);
          let ed = new Date(a.body.endDate);
          ed.setDate(ed.getDate() + 1);
          if (d < sd || d > ed) {
            alert("功能尚未開放");
            this.$router.go(-1);
            return resolve(false);
          }
        }
        resolve(true);
      });
    });
    if (!r) return false;
    this.load();
  },
  methods: {
    load() {
      this.$http.get("/api/military/info").then((a) => {
        this.item = a.body;
        this.form.status = a.body.status;
        this.form.commission = a.body.commission;
        this.form.otherReason = a.body.otherReason;
        if (this.item.idCardPosit)
          this.item.idCardPosit = "/upload/" + this.item.idCardPosit;
        if (this.item.idCardRever)
          this.item.idCardRever = "/upload/" + this.item.idCardRever;
      });
    },
    formSubmit() {
      if (this.checkForm() == false) return;
      let formData = new FormData();
      formData.append("status", this.form.status);
      formData.append("commission", this.form.commission);
      formData.append("otherReason", this.form.otherReason);
      formData.append("evidenceFile", this.form.evidenceFile);
      formData.append("idCardPosit", this.form.idCardPosit);
      formData.append("idCardRever", this.form.idCardRever);
      this.$http
        .post("/api/military/info", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((a) => {
          if (a.body.status) {
            alert("儲存成功");
            this.$refs.evidenceFile.value = null;
            this.$refs.idCardPosit.value = null;
            this.$refs.idCardRever.value = null;
            this.load();
          } else {
            alert(a.body.msg);
            console.log(a.body.exstr);
          }
        });
    },
    checkForm() {
      if (
        !this.form.status ||
        (this.form.status == "已役" && !this.form.commission) ||
        (this.form.status == "其他" && !this.form.otherReason)
      ) {
        alert("『當兵狀態』尚未選擇完整");
        return false;
      }
      if (this.form.status == "已役" || this.form.status == "其他") {
        this.form.evidenceFile = this.$refs.evidenceFile.files[0];
        if (!this.item.evidenceFile && !this.form.evidenceFile) {
          alert("『佐證資料』尚未選擇檔案");
          return false;
        }
      }
      switch (this.form.status) {
        case "未役":
          this.form.commission = null;
          this.form.otherReason = null;
          break;
        case "已役":
          this.form.otherReason = null;
          break;
        case "其他":
          this.form.commission = null;
          break;
      }
      this.form.idCardPosit = this.$refs.idCardPosit.files[0];
      if (!this.item.idCardPosit) {
        if (!this.form.idCardPosit) {
          alert("『身分證正面』尚未選擇檔案");
          return false;
        }
      }
      this.form.idCardRever = this.$refs.idCardRever.files[0];
      if (!this.item.idCardRever) {
        if (!this.form.idCardRever) {
          alert("『身分證反面』尚未選擇檔案");
          return false;
        }
      }
      return true;
    },
    idCardShow(v) {
      if (v == 0) {
        $(this.$refs.divIdCardPosit).show();
      } else {
        $(this.$refs.divIdCardRever).show();
      }
    },
    idCardHide(v) {
      if (v == 0) {
        $(this.$refs.divIdCardPosit).hide();
      } else {
        $(this.$refs.divIdCardRever).hide();
      }
    },
    checkIdCardFileIsImage(fileName) {
      if (!fileName) return false;
      let fileNameArray = fileName.split(".");
      let fileExtName = fileNameArray[fileNameArray.length - 1];
      switch (fileExtName) {
        case "jpg":
        case "png":
          return true;
      }
      return false;
    },
    statusChagne() {
      if (this.item.status) {
        if (this.form.status != this.item.status) {
          this.tempEvidenceFile = this.item.evidenceFile;
          this.item.evidenceFile = null;
        } else {
          this.item.evidenceFile = this.tempEvidenceFile;
        }
      }
    }
  }
};
</script>

<style>
</style>